module.exports = __webpack_public_path__ + "img/video_lineas_llenado.187b7c40.png";